import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import rootReducer from '../reducers';

export default (apolloClient, preloadedState = {}) => {
  const isFunction = f => typeof f === 'function';
  const enhancers = [].filter(isFunction);
  const apolloMiddleware = apolloClient && apolloClient.middleware && apolloClient.middleware();
  const middleware = [thunk, apolloMiddleware].filter(isFunction);

  // eslint-disable-next-line no-underscore-dangle
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const composedEnhancers = composeEnhancers(applyMiddleware(...middleware), ...enhancers);

  return createStore(rootReducer, preloadedState, composedEnhancers);
};



// WEBPACK FOOTER //
// ./src/store/prod.js